import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImageMapperComponent } from '@magneto/image-mapper';
import { AuthenticationGuard } from '../../guards/authentication-guard.service';

const insuranceDirectoryRoutes: Routes = [
  {
    path: 'link',
    loadChildren: () =>
      import('app/modules/insurance/modules/insurance-quick-linking.module').then((m) => m.InsuranceQuickLinkingModule),
  },
  {
    path: 'sso',
    loadComponent: () =>
      import('./modules/sso-middleware/sso-middleware.component').then((c) => c.SsoMiddlewareComponent),
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/insurance-home/insurance-home.module').then((m) => m.InsuranceHomeModule),
    canActivate: [AuthenticationGuard],
    canLoad: [AuthenticationGuard],
  },
];
@NgModule({
  imports: [CommonModule, ImageMapperComponent, RouterModule.forChild(insuranceDirectoryRoutes)],
  declarations: [],
})
export class InsuranceModule {}
